module.exports = __webpack_public_path__ + "img/gum-white.a50118d4.jpg";